import React from 'react';
import { TopPanelWrapper, ConfigWrapper } from './styled';
import Top from './TopPanel/Top';
import Content from './Content';

const ErrorLogicConfig = () => (
  <ConfigWrapper style={window.__POWERED_BY_QIANKUN__ ? { margin: 0 } : {}}>
    <>
      {window.__POWERED_BY_QIANKUN__ ? null : (
        <TopPanelWrapper>
          <Top />
        </TopPanelWrapper>
      )}
      <Content />
    </>
  </ConfigWrapper>
);

export default ErrorLogicConfig;
